import {useState} from 'react';
import type {
  ReportSimpleResponse} from 'src/api/ProactApiClient';
import {
  FeatureFlagEnum,
  ModuleEnum,
  PermissionOperationEnum
} from 'src/api/ProactApiClient';
import {ContentWrapper} from 'src/app/layout/ContentWrapper';
import {PageHeader} from 'src/design/organisms/PageHeader';

import {SidebarLinkAnalytics} from 'src/app/layout/Sidebar/SidebarLinksConfig';
import {AnalyticsDocumentTitle} from 'src/app/analytics/analyticsHelpers';
import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';
import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';
import {ReportList} from './components/ReportList';
import {ReportViewer} from './components/ReportViewer';

export const ViewReportPage = () => {
  useSetDocumentTitle(AnalyticsDocumentTitle);
  const [selectedReport, setSelectedReport] = useState<ReportSimpleResponse>();
  const selectedDashboardId = selectedReport?.dashboardId;

  return (
    <ContentWrapper featureFlag={FeatureFlagEnum.Analytics}>
      {selectedDashboardId ? (
        <>
          <ReportList
            selectedReportId={selectedDashboardId}
            onReportSelect={setSelectedReport}
          />
          <ReportViewer dashboardId={selectedDashboardId} />
        </>
      ) : (
        <>
          <PageHeader>
            <PageHeader.Title
              icon={SidebarLinkAnalytics.icon}
              subtitle="To get started, choose a report from the list below.">
              Analytics
            </PageHeader.Title>
          </PageHeader>
          <ReportList
            selectedReportId={selectedDashboardId}
            onReportSelect={setSelectedReport}
          />
        </>
      )}
    </ContentWrapper>
  );
};

// Register the route with the new system
routeRegistry.registerPageRoute({
  backNavigation: 'page',
  path: PathUtility.Analytics(),
  element: <ViewReportPage />,
  module: ModuleEnum.Analytics,
  operation: PermissionOperationEnum.View,
  isPrivate: true,
});

export default ViewReportPage;
